import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/auth.store';
import { getDefaultPostLoginPath } from '../auth';

/** Redirects verifier-only users away from dashboard to verification batches. */
const HomeRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { tokenPayload } = useAuthStore();
  const target = getDefaultPostLoginPath(tokenPayload);
  if (target !== '/') {
    return <Navigate to={target} replace />;
  }
  return <>{children}</>;
};

export default HomeRedirect;
